import React from 'react';

import IconTick from '../IconTick';
import IconCross from '../IconCross';
import IconCookieBanner from '../IconCookieBanner';
import {
  Banner,
  BannerContainer,
  ButtonLink,
  BannerCopy,
  BannerCopyAside,
  BannerCopyInner,
  BannerActions,
  BannerAction,
} from '../';

export default function CookieBanner({
  containerWidth,
  onLearnMore,
  onViewCookiePolicy,
  onOptInAll,
  onDismiss,
  theme,
}) {
  return (
    <Banner aria-live="polite" role="alert" data-testid="cookie-banner">
      <BannerContainer theme={theme} containerWidth={containerWidth} data-testid="cookie-banner-container">
        <BannerCopy>
          <BannerCopyAside>
            <IconCookieBanner />
          </BannerCopyAside>
          <BannerCopyInner>
            <h2>help us improve?</h2>
            <p>
              would you be happy to share anonymous usage statistics with us in order to help improve your experience in
              future?{' '}
              <ButtonLink role="button" onClick={onLearnMore}>
                learn more
              </ButtonLink>{' '}
              about what type of data we collect. or{' '}
              <ButtonLink role="button" onClick={onViewCookiePolicy}>
                view our cookie policy
              </ButtonLink>{' '}
              for extensive information on any data we ask your browser to keep for us.
            </p>
          </BannerCopyInner>
        </BannerCopy>
        <BannerActions>
          <BannerAction role="button" onClick={onOptInAll}>
            <IconTick />
            yes, opt in
          </BannerAction>
          <BannerAction role="button" onClick={onDismiss}>
            <IconCross />
            dismiss
          </BannerAction>
        </BannerActions>
      </BannerContainer>
    </Banner>
  );
}
